import type { InspectionType } from '@/types'

/**
 * Chart-safe (CSS var / Tailwind bg class) colors per inspection type,
 * mirroring the same palette used for the inspection type buttons/cards
 * (see INSPECTION_COLORS in constants/inspection-colors.ts) so a given
 * inspection type reads as the same color everywhere in the app.
 */
export const INSPECTION_TYPE_CHART_COLOR: Record<InspectionType, string> = {
	'see-act': 'var(--color-kaefer-grass-green)',
	directed: 'var(--color-kaefer-ocean-blue)',
	interaction: 'var(--color-kaefer-violet)',
	'yellow-card': 'var(--color-kaefer-sunny-yellow)',
}

export const INSPECTION_TYPE_BAR_CLASS: Record<InspectionType, string> = {
	'see-act': 'bg-kaefer-grass-green',
	directed: 'bg-kaefer-ocean-blue',
	interaction: 'bg-kaefer-violet',
	'yellow-card': 'bg-kaefer-sunny-yellow',
}
